import todaysMeal from "./todaysMeal";

export default {
  namespaced: true,
  modules: {
    "todays-meal": todaysMeal,
  },
};
